// extracted by mini-css-extract-plugin
module.exports = {"tabs_box":"tabs_box-275oJ-eJ","tabs":"tabs-21v8qour","mask":"mask-SMD4-dfQ"};